module.exports = __webpack_public_path__ + "img/asbjornsenmoe_02.b08dd282.jpg";